import React, { useState } from 'react';

const SaveCredentialsButton = ({ onSave }) => {
  const [showCredsModal, setShowCredsModal] = useState(false);
  const [credsDraft, setCredsDraft] = useState({
    clientId: '',
    serviceAccount: '',
    access_token: '',
  });
  const [saveMsg, setSaveMsg] = useState('');
  const [showAccessTokenInfo, setShowAccessTokenInfo] = useState(false);

  // Load from localStorage when opening
  const openCredsModal = () => {
    const creds = JSON.parse(localStorage.getItem('api_explorer_credentials') || '{}');
    setCredsDraft({
      clientId: creds.clientId || '',
      serviceAccount: creds.serviceAccount || '',
      access_token: creds.access_token || '',
    });
    setShowCredsModal(true);
  };
  const closeCredsModal = () => setShowCredsModal(false);
  const handleCredsDraftChange = (e) => {
    setCredsDraft({ ...credsDraft, [e.target.name]: e.target.value });
  };
  const handleSaveCredsModal = () => {
    localStorage.setItem('api_explorer_credentials', JSON.stringify(credsDraft));
    setShowCredsModal(false);
    setSaveMsg('Credentials saved!');
    if (onSave) onSave();
    setTimeout(() => setSaveMsg(''), 1500);
  };

  return (
    <>
      <div style={{ marginBottom: 16, display: 'flex', alignItems: 'center', gap: 12 }}>
        <button 
          className="btn" 
          style={{ 
            background: 'linear-gradient(135deg, #49cc90 0%, #3fb876 100%)',
            color: '#fff', 
            border: 'none', 
            borderRadius: 8, 
            fontWeight: 600, 
            padding: '10px 20px', 
            cursor: 'pointer',
            fontSize: '14px',
            boxShadow: '0 2px 8px rgba(73, 204, 144, 0.3)',
            transition: 'all 0.2s ease-in-out',
            position: 'relative',
            overflow: 'hidden'
          }} 
          onMouseEnter={(e) => {
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 4px 12px rgba(73, 204, 144, 0.4)';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 2px 8px rgba(73, 204, 144, 0.3)';
          }}
          onMouseDown={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 1px 4px rgba(73, 204, 144, 0.3)';
          }}
          onMouseUp={(e) => {
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 4px 12px rgba(73, 204, 144, 0.4)';
          }}
          onClick={openCredsModal}
        >
          <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
              <circle cx="12" cy="16" r="1"/>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
            </svg>
            Credentials
          </span>
        </button>
        {saveMsg && <span style={{ color: '#49cc90', fontWeight: 500 }}>{saveMsg}</span>}
      </div>
      {showCredsModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.35)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: '#fff', borderRadius: 8, padding: 32, minWidth: 320, boxShadow: '0 4px 24px rgba(0,0,0,0.15)', position: 'relative' }}>
            <h3 style={{ marginTop: 0, marginBottom: 16 }}>Save Credentials</h3>
            <div style={{ marginBottom: 12 }}>
              <label style={{ display: 'block', fontWeight: 500, marginBottom: 4 }}>clientId</label>
              <input name="clientId" value={credsDraft.clientId} onChange={handleCredsDraftChange} style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc' }} />
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={{ display: 'block', fontWeight: 500, marginBottom: 4 }}>serviceAccount</label>
              <input name="serviceAccount" value={credsDraft.serviceAccount} onChange={handleCredsDraftChange} style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc' }} />
            </div>
            <div style={{ marginBottom: 20 }}>
              <label style={{ display: 'flex', alignItems: 'center', fontWeight: 500, marginBottom: 4 }}>
                access_token
                <span
                  style={{
                    marginLeft: 6,
                    cursor: 'pointer',
                    position: 'relative',
                  }}
                  onMouseEnter={() => setShowAccessTokenInfo(true)}
                  onMouseLeave={() => setShowAccessTokenInfo(false)}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" style={{ verticalAlign: 'middle' }}>
                    <circle cx="12" cy="12" r="10" fill="#61affe" />
                    <text x="12" y="16" textAnchor="middle" fontSize="12" fill="#fff" fontFamily="Arial" fontWeight="bold">i</text>
                  </svg>
                  {showAccessTokenInfo && (
                    <div
                      style={{
                        position: 'absolute',
                        top: '100%',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        background: '#333',
                        color: '#fff',
                        padding: '8px 12px',
                        borderRadius: 4,
                        fontSize: 12,
                        whiteSpace: 'nowrap',
                        zIndex: 1001,
                        marginTop: 4,
                        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                      }}
                    >
                      This field is auto populated from the token generation API
                      <div
                        style={{
                          position: 'absolute',
                          bottom: '100%',
                          left: '50%',
                          transform: 'translateX(-50%)',
                          width: 0,
                          height: 0,
                          borderLeft: '4px solid transparent',
                          borderRight: '4px solid transparent',
                          borderBottom: '4px solid #333',
                        }}
                      />
                    </div>
                  )}
                </span>
              </label>
              <input name="access_token" value={credsDraft.access_token} onChange={handleCredsDraftChange} style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc' }} />
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
              <button onClick={closeCredsModal} style={{ background: '#eee', color: '#333', border: 'none', borderRadius: 4, padding: '6px 18px', fontWeight: 500, cursor: 'pointer' }}>Cancel</button>
              <button onClick={handleSaveCredsModal} style={{ background: '#49cc90', color: '#fff', border: 'none', borderRadius: 4, padding: '6px 18px', fontWeight: 600, cursor: 'pointer' }}>Save</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SaveCredentialsButton;
